import React from 'react';
import { Advertorial } from './components/Advertorial';
export function App() {
  return <div className="w-full min-h-screen bg-gray-100" data-id="element-0">
      <Advertorial data-id="element-1" />
    </div>;
}